module.exports = __webpack_public_path__ + "static/media/FoodSaviour-v3.1d7559a9.png";